import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/reports/payment-releasing?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement-associate/reports/payment-releasing', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement-associate/reports/payment-releasing/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement-associate/reports/payment-releasing/${payload.id}`)
  }
}

export default HistoryService
